import type { ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import Head from 'next/dist/shared/lib/head'
import { FAVICON_LINK_KEYS } from 'shared/constants'
import type { DomainAssetsInterface } from 'shared/types/domain'
import Header from 'modules/header'
import { useBrand } from 'modules/white-label/contexts/brand-context'

export interface CommunityPageLayoutProps {
  titleKey?: ParseKeys
  domainAssets?: DomainAssetsInterface
}

export const CommunityPageLayout = ({
  titleKey = 'header.nav.community',
  children,
  domainAssets,
}: React.PropsWithChildren<CommunityPageLayoutProps>): ReactNode => {
  const { t } = useTranslation()

  const { brand } = useBrand()

  return (
    <>
      <Head>
        <title>{t(titleKey)}</title>
        {domainAssets?.faviconUrl && (
          <link key={FAVICON_LINK_KEYS.icon} rel="icon" href={domainAssets.faviconUrl} />
        )}
      </Head>
      <div className="min-h-screen bg-bg-page">
        <Header
          logoSrc={domainAssets?.logoUrl || brand.logo?.path}
          headerContainerClassName="mx-auto max-w-8xl px-5 sm:px-6 md:px-14 lg:px-26"
        />
        <div className="overflow-hidden">
          <div className="mx-auto mt-10 max-w-8xl overflow-hidden px-5 sm:px-6 md:px-14 lg:px-26 lg:py-9">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export const getCommunityPageLayout = (
  page: ReactNode,
  props?: CommunityPageLayoutProps,
): ReactNode => <CommunityPageLayout {...props}>{page}</CommunityPageLayout>
